/* AURUM 79 · Etiqueta HOT DAYS por franja horaria · Built by SodaLab
   Debe coincidir con los descuentos automaticos "HOT SALE" de Shopify.
   Horas en UTC (Colombia = UTC-5). '*' = todo menos Timeless y Gems & Stones.
   Prueba: agregar ?hd_test=2026-10-16T22:30:00Z a la URL para simular una hora. */
(function(){
  var W=[
    ['2026-10-16T22:00:00Z','2026-10-17T01:00:00Z',[['metropolis ii',30],['feelings',30],['fly',30],['metropolis iii',25],['stars 1',25],['stars 2',20]]],
    ['2026-10-17T15:00:00Z','2026-10-17T18:00:00Z',[['stars 1',25],['stars 2',20]]],
    ['2026-10-18T02:00:00Z','2026-10-18T05:00:00Z',[['gems & stones',15]]],
    ['2026-10-18T22:00:00Z','2026-10-19T01:00:00Z',[['metropolis iii',25],['stars 1',25]]],
    ['2026-10-19T18:00:00Z','2026-10-19T20:00:00Z',[['stars 1',25],['stars 2',20],['gems & stones',15],['timeless',10]]],
    ['2026-10-20T18:00:00Z','2026-10-20T20:00:00Z',[['*',30]]],
    ['2026-10-21T22:00:00Z','2026-10-22T01:00:00Z',[['timeless',10]]],
    ['2026-10-22T15:00:00Z','2026-10-22T18:00:00Z',[['*',20],['timeless',15],['gems & stones',15]]],
    ['2026-10-23T22:00:00Z','2026-10-24T01:00:00Z',[['*',30],['gems & stones',15],['timeless',10]]]
  ];
  var EXC=['timeless','gems & stones'];
  var test=null; try{ var m=location.search.match(/[?&]hd_test=([^&]+)/); if(m) test=Date.parse(decodeURIComponent(m[1])); }catch(e){}
  function now(){ return test||Date.now(); }
  function active(){ var t=now(); for(var i=0;i<W.length;i++){ if(t>=Date.parse(W[i][0])&&t<Date.parse(W[i][1])) return W[i][2]; } return null; }
  function pct(tags,rules){
    var best=0;
    for(var i=0;i<rules.length;i++){
      var tag=rules[i][0], p=rules[i][1], hit=false;
      if(tag==='*'){ hit=EXC.every(function(x){ return tags.indexOf(x)<0; }); }
      else { hit=tags.indexOf(tag)>-1; }
      if(hit&&p>best) best=p;
    }
    return best;
  }
  function run(){
    var rules=active();
    var els=document.querySelectorAll('.sl-hd[data-hd]');
    for(var i=0;i<els.length;i++){
      var el=els[i], p=0;
      if(rules){ p=pct(el.getAttribute('data-hd').split('|'),rules); }
      if(p>0){ el.textContent='-'+p+'%'; el.hidden=false; } else { el.hidden=true; }
    }
  }
  var to=null;
  function soon(){ clearTimeout(to); to=setTimeout(run,120); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  try{ new MutationObserver(soon).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
  setInterval(run,30000);
})();